if (!customElements.get('sezzle-widget')) {
	// Sezzle can't pay for subscriptions; theme.css hides the widget while the page's purchase type is Subscribe & Save
	// and the variant offers it.
	class SezzleWidget extends HTMLElement {
		static CLASSES = {
			INACTIVE: 'sezzle-widget--inactive',
		};

		static ATTRIBUTES = {
			SUBSCRIBABLE: 'data-subscribable',
		};

		connectedCallback() {
			this.widget ??= this.#render();
			const { EventManager } = window.UFT;
			this.unsubscribers = [EventManager.on(EventManager.eventStrings.PRODUCT_HTML_UPDATED, this.#onHtmlUpdated)];
		}

		disconnectedCallback() {
			this.unsubscribers?.forEach((unsubscribe) => unsubscribe());
		}

		#render() {
			const widget = new AwesomeSezzle({
				amount: this.dataset.sezzleAmount,
				widgetType: 'product-page',
				renderElement: `${this.id}-render`,
				alignment: this.dataset.alignment,
			});
			widget.init();
			return widget;
		}

		// product-manager's rerendered section markup carries the server's amount, active state and Subscribe & Save
		// offer for the selected variant. The floating ATC isn't in that markup, so it follows any active site there.
		#onHtmlUpdated = ({ section }) => {
			// A plan picker swapping its markup detaches this element mid-dispatch; its replacement is current.
			if (!this.isConnected) {
				return;
			}
			const { INACTIVE } = SezzleWidget.CLASSES;
			const own = section.getElementById(this.id);
			const updated = own || section.querySelector(`sezzle-widget:not(.${INACTIVE})`);
			if (!updated) {
				return;
			}
			if (own) {
				this.classList.toggle(INACTIVE, own.classList.contains(INACTIVE));
			}
			this.toggleAttribute(
				SezzleWidget.ATTRIBUTES.SUBSCRIBABLE,
				updated.hasAttribute(SezzleWidget.ATTRIBUTES.SUBSCRIBABLE)
			);
			if (updated.dataset.sezzleAmount === this.dataset.sezzleAmount) {
				return;
			}
			this.dataset.sezzleAmount = updated.dataset.sezzleAmount;
			this.widget.alterPrice(updated.dataset.sezzleAmount);
		};
	}
	customElements.define('sezzle-widget', SezzleWidget);
}
